import { Component, OnInit } from '@angular/core';
import { PayrixService } from '../service/payrix.service';

@Component({
  selector: 'edex-payment-container',
  templateUrl: './payment-container.component.html',
  styleUrls: ['./payment-container.component.scss']
})
export class PaymentContainerComponent implements OnInit {
  loading = false;
  paymentProcessor = ''
  constructor(private paymentService: PayrixService) { 
    this.getPaymentProcessor();
  }

  ngOnInit() {
  }

  getPaymentProcessor() {
    this.loading = true;
    this.paymentService.getPaymentProcessor().subscribe(
      res => {
        this.loading = false;
        if(res.status && res.result) {
         this.paymentProcessor = res.result;
         if(this.paymentProcessor == 'Paypal') {
           window.location.replace(`/paypal-payment${window.location.search}`);
         } else if(this.paymentProcessor == 'Payrix') {
          window.location.replace(`/payrix-payment-field${window.location.search}`);
        } else if(this.paymentProcessor == 'Stripe') {
          window.location.replace(`/stripe-payment${window.location.search}`);
        } 
        }
      }, error => {
        this.loading = false;
      }
    )
  }
}
